// Shared by OrganizationContext (which owns reading/writing the full selection) and
// httpClient (which only needs to invalidate a stale selection on specific auth errors,
// and can't import OrganizationContext directly without creating a circular dependency).
export const ACTIVE_SELECTION_STORAGE_KEY = "bb_active_selection";

export function clearActiveSelectionStorage(): void {
  try {
    localStorage.removeItem(ACTIVE_SELECTION_STORAGE_KEY);
  } catch {
    // localStorage can throw in restrictive environments (e.g. Safari private browsing) —
    // nothing to clean up in that case.
  }
}
